export const TABLE_CUPOS = 'TABLE_CUPOS'
export const TABLE_CUPOS_DISPONIBLES = 'TABLE_CUPOS_DISPONIBLES'
export const TABLE_CUPOS_ASIGNADOS_POR_CEREAL = 'TABLE_CUPOS_ASIGNADOS_POR_CEREAL'
export const TABLE_TOTAL_CUPOS_ASIGNADOS = 'TABLE_TOTAL_CUPOS_ASIGNADOS'
export const TABLE_CUPOS_HISTORICO = 'TABLE_CUPOS_HISTORICO'
export const TABLE_CUPOS_NOMINADOS = 'TABLE_CUPOS_NOMINADOS'
export const TABLE_SILOS = 'TABLE_SILOS'
export const TABLE_ESTADO_ELEVADOR = 'TABLE_ESTADO_ELEVADOR'
export const TABLE_REPORTE_ESTADO_POR_SILO = 'TABLE_REPORTE_ESTADO_POR_SILO'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_UNO = 'TABLE_REPORTE_ESTADO_POR_SECTOR_UNO'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_DOS = 'TABLE_REPORTE_ESTADO_POR_SECTOR_DOS'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_TRES = 'TABLE_REPORTE_ESTADO_POR_SECTOR_TRES'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO = 'TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO = 'TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO'
export const TABLE_TOTAL_ESTADO_POR_SECTOR_UNO = 'TABLE_TOTAL_ESTADO_POR_SECTOR_UNO'
export const TABLE_TOTAL_ESTADO_POR_SECTOR_DOS = 'TABLE_TOTAL_ESTADO_POR_SECTOR_DOS'
export const TABLE_TOTAL_ESTADO_POR_SECTOR_TRES = 'TABLE_TOTAL_ESTADO_POR_SECTOR_TRES'
export const TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO = 'TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO'
export const TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO = 'TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO'
export const TABLE_REPORTE_ESTADO_POR_SECTOR_Y_LINEA = 'TABLE_REPORTE_ESTADO_POR_SECTOR_Y_LINEA'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO = 'TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA = 'TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ = 'TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO = 'TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE = 'TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC = 'TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ = 'TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC = 'TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG = 'TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG'
export const TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS = 'TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO = 'TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA = 'TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ = 'TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO = 'TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE = 'TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC = 'TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ = 'TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC = 'TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG = 'TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG'
export const TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS = 'TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS'
export const TABLE_REPORTE_ESTADO_POR_CEREAL = 'TABLE_REPORTE_ESTADO_POR_CEREAL'
export const TABLA_EXISTENCIA_DIARIA = 'TABLA_EXISTENCIA_DIARIA'
export const TABLA_EXISTENCIA_DIARIA_VARIEDAD = 'TABLA_EXISTENCIA_DIARIA_VARIEDAD'
export const TABLA_CONSULTA_POR_COSECHA = 'TABLA_CONSULTA_POR_COSECHA'
export const TABLA_DETALLE_CONSULTA_POR_COSECHA = 'TABLA_DETALLE_CONSULTA_POR_COSECHA'
export const TABLA_MERCADERIA_FUMIGADA = 'TABLA_MERCADERIA_FUMIGADA'
export const TABLE_CARTAS_DE_PORTE_VETADAS = 'TABLE_CARTAS_DE_PORTE_VETADAS'
export const TABLA_DETALLE_MERCADERIA_FUMIGADA = 'TABLA_DETALLE_MERCADERIA_FUMIGADA'
export const DETALLE_TABLE_CARTAS_DE_PORTE_VETADAS = 'DETALLE_TABLE_CARTAS_DE_PORTE_VETADAS'
export const TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL = 'TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL'
export const TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS = 'TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA_PROGRESS_BARS'
export const TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA = 'TABLE_CONSULTA_TOTAL_ESPACIO_SILO_CEREAL_POR_LINEA'
export const TABLA_MERCADERIA_SECADA = 'TABLA_MERCADERIA_SECADA'
export const TABLA_MERCADERIA_SECADA_DOS_MAS = 'TABLA_MERCADERIA_SECADA_DOS_MAS'
export const TABLA_DETALLE_SECADA_2_MAS = 'TABLA_DETALLE_SECADA_2_MAS'
export const TABLA_DETALLE_MERCADERIA_SECADA = 'TABLA_DETALLE_MERCADERIA_SECADA'
export const TABLA_TOTAL_DESCARGA_POR_GRADO = 'TABLA_TOTAL_DESCARGA_POR_GRADO'
export const TABLA_DETALLE_DESCARGA_POR_GRADO = 'TABLA_DETALLE_DESCARGA_POR_GRADO'
export const TABLA_TOTAL_MERCADERIA_GRADO_3 = 'TABLA_TOTAL_MERCADERIA_GRADO_3'
export const TABLA_DETALLE_DESCARGA_GRADO_3 = 'TABLA_DETALLE_DESCARGA_GRADO_3'
export const TABLA_TOTAL_FUERA_DE_GRADO = 'TABLA_TOTAL_FUERA_DE_GRADO'
export const TABLA_DETALLE_FUERA_DE_GRADO = 'TABLA_DETALLE_FUERA_DE_GRADO'
export const TABLA_MERCADERIA_REBAJA_ADICIONAL = 'TABLA_MERCADERIA_REBAJA_ADICIONAL'
export const TABLA_TOTAL_ALMACENAJE = 'TABLA_TOTAL_ALMACENAJE'
export const TABLA_MOVIMIENTOS_DIARIOS_EXP = 'TABLA_MOVIMIENTOS_DIARIOS_EXP'
export const TABLA_TRANSFERENCIAS_EXPORTADOR = 'TABLA_TRANSFERENCIAS_EXPORTADOR'
export const TABLA_ALMACENAJE_ESPECIAL = 'TABLA_ALMACENAJE_ESPECIAL'
export const TABLA_DETALLE_ALMACENAJE_ESPECIAL = 'TABLA_DETALLE_ALMACENAJE_ESPECIAL'
export const TABLA_TOTAL_ZARANDEO = 'TABLA_TOTAL_ZARANDEO'
export const TABLA_DETALLE_ZARANDEO = 'TABLA_DETALLE_ZARANDEO'
export const TABLA_STOCK_INDICES = 'TABLA_STOCK_INDICES'
export const TABLA_ESTIMACION_SEMANAL = 'TABLA_ESTIMACION_SEMANAL'
export const TABLA_ESTIMACION_SEMANAL_CEREAL = 'TABLA_ESTIMACION_SEMANAL_CEREAL'
export const TABLA_STOCK_EXPORTADOR = 'TABLA_STOCK_EXPORTADOR'
export const TABLA_SIMULACION_POOL = 'TABLA_SIMULACION_POOL'
export const TABLA_SIMULACION_0 = 'TABLA_SIMULACION_0'
export const TABLA_SIMULACION_1 = 'TABLA_SIMULACION_1'
export const TABLA_SIMULACION_2 = 'TABLA_SIMULACION_2'
export const TABLA_SIMULACION_3 = 'TABLA_SIMULACION_3'
export const TABLA_PROYECCION_EXPORTADOR = 'TABLA_PROYECCION_EXPORTADOR'
export const TABLA_MOVIMIENTOS_EXPORTADOR = 'TABLA_MOVIMIENTOS_EXPORTADOR'
export const TABLA_DETALLE_MOVIMIENTOS_EXP = 'TABLA_DETALLE_MOVIMIENTOS_EXP'
export const TABLE_REPORTE_TOTAL_SILO_CEREAL = 'TABLE_REPORTE_TOTAL_SILO_CEREAL'
export const TABLE_REPORTE_TOTAL_SILO_ETIQUETA_SECTOR = 'TABLE_REPORTE_TOTAL_SILO_ETIQUETA_SECTOR'
export const TABLE_REPORTE_TOTAL_SILO_LINEAL = 'TABLE_REPORTE_TOTAL_SILO_LINEAL'
export const TABLE_REPORTE_TOTAL_ESPACIO_ELEVADOR = 'TABLE_REPORTE_TOTAL_ESPACIO_ELEVADOR'
export const TABLE_REPORTE_POR_SILOS = 'TABLE_REPORTE_POR_SILOS'
export const TABLE_DISTRIBUCION_POR_CEREAL = ' TABLE_DISTRIBUCION_POR_CEREAL'
export const TABLE_DISTRIBUCION_POR_CONDICION = 'TABLE_DISTRIBUCION_POR_CONDICION'
export const TABLA_DISTRIBUCION_POR_ESPACIO = 'TABLA_DISTRIBUCION_POR_ESPACIO'
export const TABLA_BUQUES = 'TABLA_BUQUES'
export const TABLA_COMUNICACIONES_ACTIVAS = 'TABLA_COMUNICACIONES_ACTIVAS'
export const TABLA_COMUNICACIONES_INACTIVAS = 'TABLA_COMUNICACIONES_INACTIVAS'
export const TABLA_COMUNICACIONES_FINALIZADAS = 'TABLA_COMUNICACIONES_FINALIZADAS'
export const TABLA_COMUNICACIONES_HISTORIAL = 'TABLA_COMUNICACIONES_HISTORIAL'
export const TABLA_EXPORTADORES_POR_CARATULA = 'TABLA_EXPORTADORES_POR_CARATULA'
export const TABLA_COEM_HISTORIAL = 'TABLA_COEM_HISTORIAL'
export const TABLA_COEMS = 'TABLA_COEMS'
export const TABLA_COEMS_FINALIZADOS = 'TABLA_COEMS_FINALIZADOS'
export const TABLA_COEMS_CERRADOS = 'TABLA_COEMS_CERRADOS'
export const TABLA_COEMS_ANULADOS = 'TABLA_COEMS_ANULADOS'
export const TABLA_CACHE_CUPOS_A_NOMINAR = 'TABLA_CACHE_CUPOS_A_NOMINAR'
export const TABLA_DETALLE_POR_CEREAL_LINEA_12 = 'TABLA_DETALLE_POR_CEREAL_LINEA_12'
export const TABLA_DETALLE_POR_CEREAL_LINEA_3 = 'TABLA_DETALLE_POR_CEREAL_LINEA_3'
export const TABLA_DETALLE_POR_CEREAL_LINEA_4 = 'TABLA_DETALLE_POR_CEREAL_LINEA_4'
export const TABLA_DETALLE_POR_CEREAL_LINEA_5 = 'TABLA_DETALLE_POR_CEREAL_LINEA_5'
export const TABLA_DETALLE_POR_CONDICION_LINEA_12 = 'TABLA_DETALLE_POR_CONDICION_LINEA_12'
export const TABLA_DETALLE_POR_CONDICION_LINEA_3 = 'TABLA_DETALLE_POR_CONDICION_LINEA_3'
export const TABLA_DETALLE_POR_CONDICION_LINEA_4 = 'TABLA_DETALLE_POR_CONDICION_LINEA_4'
export const TABLA_DETALLE_POR_CONDICION_LINEA_5 = 'TABLA_DETALLE_POR_CONDICION_LINEA_5'
export const TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_12 = 'TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_12'
export const TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_3 = 'TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_3'
export const TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_4 = 'TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_4'
export const TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5 = 'TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5'
export const TABLA_CAMIONES_EN_TRANSITO = 'TABLA_CAMIONES_EN_TRANSITO'
export const TABLA_CAMIONES_EN_TRANSITO_TOTAL = 'TABLA_CAMIONES_EN_TRANSITO_TOTAL'
export const TABLA_CAMIONES_EN_CIRCUITO = 'TABLA_CAMIONES_EN_CIRCUITO'
export const TABLA_TOTAL_CAMIONES_EN_CIRCUITO = 'TABLA_TOTAL_CAMIONES_EN_CIRCUITO'
export const TABLA_CAMIONES_PENALIZADOS = 'TABLA_CAMIONES_PENALIZADOS'
export const TABLA_CAMIONES_CALADO = 'TABLA_CAMIONES_CALADO'
export const TABLA_CALLES_DE_CALADO = 'TABLA_CALLES_DE_CALADO'
export const TABLA_CAMIONES_DESCARGADOS = 'TABLA_CAMIONES_DESCARGADOS'
export const TABLA_CAMIONES_EN_PLAYA = 'TABLA_CAMIONES_EN_PLAYA'
export const TABLA_CAMIONES_SIN_DEFINITIVA = 'TABLA_CAMIONES_SIN_DEFINITIVA'
export const TABLA_CAMIONES_ENTRE_PLAYA_CALADO = 'TABLA_CAMIONES_ENTRE_PLAYA_CALADO'
export const TABLA_PEDIDO_CAMIONES_EN_PLAYA = 'TABLA_PEDIDO_CAMIONES_EN_PLAYA'
export const TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA = 'TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA'
export const TABLA_PEDIDO_CAMIONES_EN_CALADO = 'TABLA_PEDIDO_CAMIONES_EN_CALADO'
export const TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO = 'TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO'
export const TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE = 'TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE'
export const TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE = 'TABLA_CAMIONES_RECHAZADOS_ADMINISTRATIVAMENTE'
export const TABLA_CAMIONES_RECHAZADOS_EN_CALADO = 'TABLA_CAMIONES_RECHAZADOS_EN_CALADO'
export const TABLA_MOVIMIENTOS_DE_MERCADERIA = 'TABLA_MOVIMIENTOS_DE_MERCADERIA'
export const TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES = 'TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES'
export const TABLA_CAMIONES_PARA_AUTORIZAR = 'TABLA_CAMIONES_PARA_AUTORIZAR'
export const TABLA_CAMIONES_SIN_CUPO = 'TABLA_CAMIONES_SIN_CUPO'
export const TABLA_CAMIONES_VOLCADOS = 'TABLA_CAMIONES_VOLCADOS'
export const TABLA_CODIGO_DE_CUPOS = 'TABLA_CODIGO_DE_CUPOS'
export const TABLA_CUPOS_ASIGNADOS = 'TABLA_CUPOS_ASIGNADOS'
export const TABLA_CUPOS_CONSUMIDOS = 'TABLA_CUPOS_CONSUMIDOS'
export const TABLA_CUPOS_NOMINADOS = 'TABLA_CUPOS_NOMINADOS'
export const TABLA_CUPOS_NOMINADOS_HISTORICO = 'TABLA_CUPOS_NOMINADOS_HISTORICO'
export const TABLA_DESCARGA_PROCESADA = 'TABLA_DESCARGA_PROCESADA'
export const TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO = 'TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO'
export const TABLA_CAMIONES_LISTOS_PARA_BRUTO = 'TABLA_CAMIONES_LISTOS_PARA_BRUTO'
export const TABLA_CAMIONES_RECHAZADOS_EN_BRUTO = 'TABLA_CAMIONES_RECHAZADOS_EN_BRUTO'
export const TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5 = 'TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5'
export const TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_6 = 'TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_6'
export const TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7 = 'TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7'
export const TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_5 = 'TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_5'
export const TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7 = 'TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7'
export const TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_6 = 'TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_6'
export const TABLA_REPORTE_EMBARQUE_SECTOR_4 = 'TABLA_REPORTE_EMBARQUE_SECTOR_4'
export const TABLA_REPORTE_EMBARQUE_SECTOR_5 = 'TABLA_REPORTE_EMBARQUE_SECTOR_5'
export const TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR = 'TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR'
export const TABLA_MENU_DE_MUESTRAS = 'TABLA_MENU_DE_MUESTRAS'
export const TABLE_CAMIONES_CALADOS = 'TABLE_CAMIONES_CALADOS'
export const TABLE_CAMIONES_DESCARGADOS = 'TABLE_CAMIONES_DESCARGADOS'
export const TOTAL_CUPOS_CONSUMIDOS = 'TOTAL_CUPOS_CONSUMIDOS'
export const TOTAL_CUPOS_NOMINADOS = 'TOTAL_CUPOS_NOMINADOS'
export const TABLA_CUPOS_A_ASIGNAR = 'TABLA_CUPOS_A_ASIGNAR'
export const TABLA_CUPOS_A_NOMINAR = 'TABLA_CUPOS_A_NOMMINAR'
export const TABLA_CUMPLIMIENTO_DE_CUPOS = 'TABLA_CUMPLIMIENTO_DE_CUPOS'
export const TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR = 'TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR'
export const TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES = 'TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES'
export const TABLA_CORREOS_UPDATE = 'TABLA_CORREOS_UPDATE'
export const TABLA_LINE_UP_BUQUES = 'TABLA_LINE_UP_BUQUES'
export const TABLA_CARGA_BUQUES = 'TABLA_CARGA_BUQUES'
export const TABLA_CAMIONES_CALADO_EN_CALLES = 'TABLA_CAMIONES_CALADO_EN_CALLES'
export const TABLA_PLAN_DE_EMBARQUE = 'TABLA_PLAN_DE_EMBARQUE'
export const TABLA_PLAN_DE_EMBARQUE_ACTIVO = 'TABLA_PLAN_DE_EMBARQUE_ACTIVO'
export const TABLA_BODEGA_BUQUE = 'TABLA_BODEGA_BUQUE'
export const TABLA_HISTOGRAMA_VOLCADORA = 'TABLA_HISTOGRAMA_VOLCADORA'
export const TABLA_HISTOGRAMA_INGRESO_POR_CEREAL = 'TABLA_HISTOGRAMA_INGRESO_POR_CEREAL'
export const TABLA_HISTOGRAMA_INGRESO_POR_USUARIO = 'TABLA_HISTOGRAMA_INGRESO_POR_USUARIO'
export const TABLA_HISTOGRAMA_CALADO_POR_PUESTO = 'TABLA_HISTOGRAMA_CALADO_POR_PUESTO'
export const TABLA_HISTOGRAMA_BALANZA_BRUTO = 'TABLA_HISTOGRAMA_BALANZA_BRUTO'
export const TABLA_HISTOGRAMA_BALANZAS = 'TABLA_HISTOGRAMA_BALANZAS'
export const TABLA_DEMORA_EN_VOLCADORAS = 'TABLA_DEMORA_EN_VOLCADORAS'
export const TABLA_ESTADISTICAS_VOLCADORAS = 'TABLA_ESTADISTICAS_VOLCADORAS'
export const TABLA_CDMD_EXPORTADOR_CEREAL = 'TABLA_CDMD_EXPORTADOR_CEREAL'
export const TABLA_CDMD_CEREAL_PESO_TOTAL = 'TABLA_CDMD_CEREAL_PESO_TOTAL'
export const TABLA_ACTIVIDAD_BARRERA_BRUTO = 'TABLA_ACTIVIDAD_BARRERA_BRUTO'
export const TABLA_CAMIONES_CON_REMITO = 'TABLA_CAMIONES_CON_REMITO'
export const TABLA_CDMD_TOTAL_CUPOS = 'TABLA_CDMD_TOTAL_CUPOS'
export const TABLA_POSIBLES_ARRIBOS = 'TABLA_POSIBLES_ARRIBOS'
export const TABLA_MONITOR_EMBARQUE_BUQUE = 'TABLA_MONITOR_EMBARQUE_BUQUE'
export const TABLA_MONITOR_EMBARQUE_EXPORTADOR = 'TABLA_MONITOR_EMBARQUE_EXPORTADOR'
export const TABLA_MONITOR_BODEGA_DESTINO = 'TABLA_MONITOR_BODEGA_DESTINO'
export const TABLA_RECONOCIMIENTO_STOCK = 'TABLA_RECONOCIMIENTO_STOCK'
export const TABLA_STOCK_PRESUNTO_TERMINAL = 'TABLA_STOCK_PRESUNTO_TERMINAL'
